// extracted by mini-css-extract-plugin
export default {"IconDefault":"CheckedIcon_IconDefault__wsfnr","IconSelected":"CheckedIcon_IconSelected__r21BP"};